/**
 * The narrow screen (D-215): below 900px the rail is a drawer behind the header's menu button.
 * The stylesheet draws every layout (`responsive.css`); this answers only what the markup itself
 * must know — whether the rail may fold to icons, and whether the drawer is a thing at all.
 * `NARROW_QUERY` is the one breakpoint both sides read: change it here and in `responsive.css`.
 */

import { useSyncExternalStore } from 'react';

export const NARROW_QUERY = '(max-width: 900px)';

/**
 * A phone (design 51, D-321): `responsive.css`'s phone step, the same line. Read once when Receive opens — a phone gets
 * its own flow, everything wider the desktop dialog — and kept until it closes, so a phone turned sideways never swaps.
 */
export const PHONE_QUERY = '(max-width: 720px)';

/** The rail folds to icons only on a wide screen; in the drawer it always shows its labels. */
export function railFolded(collapsedPreference: boolean, narrow: boolean): boolean {
  return collapsedPreference && !narrow;
}

/** Whether a media query matches, kept current as the window is resized or turned. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export function useNarrow(): boolean {
  return useMediaQuery(NARROW_QUERY);
}
